import { useCallback, useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useSceneElement } from '@editor/hooks'
import { ImmutableVector3 } from '@modugen/ui-toolkit'
import VerticalSlabEdgeDrawing from '.'

interface Props {
  elementGuid: string
  elementType: 'vertical_slabs' | 'vertical_roof_slabs'
}

const VerticalSlabEdgeDrawingScene = ({ elementGuid, elementType }: Props) => {
  const { setValue } = useFormContext()
  const points = useWatch({ name: 'shape.points' }) as ImmutableVector3[] | undefined

  const updatePoints = useCallback(
    (nextPoints: ImmutableVector3[]) => {
      setValue('shape.points', nextPoints, { shouldDirty: true })
    },
    [setValue],
  )

  const sceneElement = useMemo(
    () => ({
      enabled: points?.length === 4,
      properties: {
        points: points ?? [],
        updatePoints,
        element: elementGuid,
        elementType,
      },
      component: VerticalSlabEdgeDrawing,
    }),
    [points, updatePoints, elementGuid, elementType],
  )

  useSceneElement(sceneElement)

  return null
}

export default VerticalSlabEdgeDrawingScene
